import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import NextSteps from '../../components/NextSteps/NextSteps'
import Layout from '../../components/layout/layout'
import ContactForm from '../../components/contactform/contactform'
import BookingCalendar from '../../components/BookingCalendar/BookingCalendar'
import Reveal from '../../components/Reveal/Reveal'
import './contactUs.scss'
import { LanguageContext } from '../../components/LanguageSwitcher/LanguageContext'
import Seo, { breadcrumbJsonLd, organizationJsonLd } from '../../components/Seo/Seo'

const ContactUs = () => {
  const { translations } = useContext(LanguageContext);
  const { hash } = useLocation()

  // Links like /contact-us#book land straight on the calendar.
  useEffect(() => {
    if (hash !== '#book') return undefined
    const timer = setTimeout(() => {
      const el = document.getElementById('book')
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 350)
    return () => clearTimeout(timer)
  }, [hash])

  return (
    <Layout>
      <Seo
        title='Contact Us — Start Your ML Project'
        description='Get in touch with MLMind to discuss your machine learning or AI project. Book a call, send a message, or email us — we reply within one business day.'
        jsonLd={[
          organizationJsonLd(),
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'Contact us', path: '/contact-us' },
          ]),
        ]}
      />
      <div className='contact-page-container'>
        <div className='contact-page-content'>
          <div className='contact-main-box'>

            <div>
              <h1 className='contact-start'>{translations.contact11}</h1>
              <h3 className='contact-let-us'> {translations.contact12}</h3>
              <p className='contact-get-touch'>{translations.contact13}</p>

              <div className='contact-hrefs'>
                <a href="tel:+995599239551" className="phone-link">
                  +995 599 239 551
                </a>
                <a href="mailto:mlmindbusiness@gmail.com" className="email-link">
                  mlmindbusiness@gmail.com
                </a>

              </div>

              <ul className='contact-reassurance'>
                <li>{translations.homeUsp1}</li>
                <li>{translations.homeUsp2}</li>
                <li>{translations.homeUsp3}</li>
              </ul>

              <NextSteps />
            </div>
            <ContactForm />
          </div>

          <div id='book' className='contact-book-anchor'>
            <Reveal>
              <BookingCalendar />
            </Reveal>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ContactUs
